export default __webpack_public_path__ + "static/media/Reebok.b733050e.svg";